import React from "react";
import * as ReactDOMClient from "react-dom/client";
import "./index.css";
import "./styles/global.css";
import "./styles/dark.css";
import "react-loading-skeleton/dist/skeleton.css";

import "./styles/icons/icons.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./app/store";
import axios from "axios";
import { initSystemLogs } from "./services/systemLogs";
import { safeParseCookie } from "./utils/safeParseCookie";

// Parsed defensively: a corrupt cookie must never throw before React mounts.
const token = safeParseCookie("token", { allowRaw: true });

if (token) axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
initSystemLogs();

const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
);
